import { render, staticRenderFns } from "./sharedResourceAgreementManage.vue?vue&type=template&id=0c9fa6fa&scoped=true"
import script from "./sharedResourceAgreementManage.vue?vue&type=script&lang=js"
export * from "./sharedResourceAgreementManage.vue?vue&type=script&lang=js"
import style0 from "./sharedResourceAgreementManage.vue?vue&type=style&index=0&id=0c9fa6fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9fa6fa",
  null
  
)

export default component.exports